export const BASE_BACKEND_URL = '/api';
export const BASE_BACKEND_QUERY_KEY = 'api';

export const MAX_REQUEST_RETRIES = 1;

/**
 * Constants used to build reusable query keys
 */
export const QUERY_KEYS = {
  article: 'article',
  cart: 'cart',
  customer: 'customer',
  openOrders: 'openOrders',
  orders: 'orders',
  recentArticles: 'recentArticles',
  series: 'series',
} as const;
